import { onScopeDispose } from 'vue';

interface UseLongPressOptions {
	threshold?: number;
	movementThreshold?: number;
}

interface UseLongPressBindings {
	onPointerdown: (event: PointerEvent) => void;
	onPointerup: () => void;
	onPointerleave: () => void;
	onPointermove: (event: PointerEvent) => void;
	onPointercancel: () => void;
}

const DEFAULT_THRESHOLD = 400;
const DEFAULT_MOVEMENT_THRESHOLD = 10;

export function useLongPress(callback: () => void, options: UseLongPressOptions = {}): UseLongPressBindings {
	const { threshold = DEFAULT_THRESHOLD, movementThreshold = DEFAULT_MOVEMENT_THRESHOLD } = options;

	let timer: ReturnType<typeof setTimeout> | null = null;
	let startX = 0;
	let startY = 0;

	function clear() {
		if (timer !== null) {
			clearTimeout(timer);
			timer = null;
		}
	}

	function onPointerdown(event: PointerEvent) {
		clear();
		startX = event.clientX;
		startY = event.clientY;

		timer = setTimeout(() => {
			timer = null;
			callback();
		}, threshold);
	}

	function onPointermove(event: PointerEvent) {
		if (timer === null) return;

		if (Math.abs(event.clientX - startX) > movementThreshold || Math.abs(event.clientY - startY) > movementThreshold) {
			clear();
		}
	}

	onScopeDispose(clear, true);

	return {
		onPointerdown,
		onPointerup: clear,
		onPointerleave: clear,
		onPointermove,
		onPointercancel: clear,
	};
}
